import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const labPharmacyListsRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/pharmacy_lists',
  validateSearch: z.object({
    tab: z.enum(['active', 'archived']).default('active'),
    query: z.string().optional(),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/lab/PharmacyLists/LabPharmacyListsPage/LabPharmacyListsPage').then((d) => d.Route)
);
